/**
 * Wrapper for CommentPopup to position it in 3D space.
 * It also wraps CommentPopup in redux Provider since it does not get forwarded automatically
 */
import { FC } from 'react'

import { GlobalModalContext } from '@editor/contexts/GlobalModal'
import { RouterContext } from '@editor/contexts/Router'
import { UserContext } from '@editor/contexts/Users'
import CommentPopup from '@editor/pages/projects/common/Comments/CommentPopup'
import { CommentPopupProps } from '@editor/pages/projects/common/Comments/hooks/commentPopup'
import { store } from '@editor/store/app'
import { StylesProvider } from '@infraloop/common'
import { Html, useContextBridge } from '@react-three/drei'
import { useThree } from '@react-three/fiber'
import { Provider } from 'react-redux'
import { Vector3 } from 'three'

export const CommentPopup3d: FC<CommentPopupProps> = (props) => {
  const { comment } = props
  const { gl } = useThree()

  // Forward contexts to CommentPopup. This has to be done again due to
  // another Html wrapping causing lose of context
  const ContextBridge = useContextBridge(UserContext, GlobalModalContext, RouterContext)

  return (
    <Html
      position={
        new Vector3(
          comment.cartesian_position?.x || 0,
          comment.cartesian_position?.y || 0,
          comment.cartesian_position?.z || 0,
        )
      }
      portal={{ current: document.getElementById('canvasBox') || gl.domElement }}
      zIndexRange={[1000, 1000]}
    >
      <ContextBridge>
        <Provider store={store}>
          <StylesProvider>
            <CommentPopup {...props} />
          </StylesProvider>
        </Provider>
      </ContextBridge>
    </Html>
  )
}
